import { trim } from "lodash";

export default class AdminAulaImportarForm {

    /**
     *
     * @param {string} data.empresaId
     * @param {string} data.empresaNombre
     * @param {Array} data.grados
     * @param {Array} data.secciones
     */
    constructor(data){
        this.empresaId = data.empresaId;
        this.empresaNombre = data.empresaNombre;
        this.grados = data.grados;
        this.secciones = data.secciones;
        this.aulas = [];
    }

    /**
     *
     * @param {callback} options.onSuccess
     */
    nuevo(options) {
        let myself = this;
        let modalOpts = {
            title: 'Agregar aulas - ' + myself.empresaNombre,
            method: 'POST',
            url: '/api/admin/aulas/import'
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    label: 'Importar',
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        this.modal.render(this.render(), function() {
            let tbody = document.querySelector('.bootbox #aulas-para-importar tbody');
            let btnImportar = document.querySelector('.bootbox .bootbox-accept');
            let txtData = document.querySelector('.bootbox #data-importar');
            let form = document.querySelector('.bootbox form #hidden-fields');
            btnImportar.disabled = true;
            $('.bootbox #btn-formatear-datos').click(function() {
                form.innerHTML = '';
                myself.aulas = [];
                tbody.innerHTML = '';
                if (txtData.value != '') {
                    txtData.value.split("\n").forEach(ln => {
                        if (ln != '') {
                            let arrAula = ln.split("\t");
                            let grado = myself.grados.find(g => g.otrosSimbolos.findIndex(os => os == arrAula[0].trim()) > -1);
                            let seccion = arrAula[1].trim();
                            let correos = [];
                            arrAula[2].trim().split(',').forEach(c => {
                                let correo = c.trim();
                                if (correo != '') {
                                    correos.push(correo);
                                }
                            });
                            if (grado != null && seccion != null) {
                                myself.aulas.push({
                                    grado: grado,
                                    seccion: seccion,
                                    correos: correos,
                                });
                            }
                        }
                    });
                    if (myself.aulas.length > 0) {
                        myself.aulas.forEach((d, i) => {
                            tbody.innerHTML += `<tr>
                            <td>${i + 1}</td>
                            <td>${d.grado.nombre}</td>
                            <td>${d.seccion}</td>
                            <td>${d.correos.join(', ')}</td>
                            </tr>`;
                            form.innerHTML += `<input type="hidden" name="aula[${i}][empresa_id]" value="${myself.empresaId}"/>
                            <input type="hidden" name="aula[${i}][grado]" value="${d.grado.id}"/>
                            <input type="hidden" name="aula[${i}][seccion]" value="${d.seccion}"/>`;
                            d.correos.forEach(c => {
                                form.innerHTML += `<input type="hidden" name="aula[${i}][correos][]" value="${c.trim()}"/>`;
                            });
                        });
                        btnImportar.disabled = false;
                    } else {
                        $.notify('No hay nada para formatear', 'info');
                    }
                } else {
                    $.notify('No hay nada para formatear', 'danger');
                }
            });
        });
    }

    render() {
        let anho = (new Date()).getFullYear();
        let anhosOpt = '';
        for (let a = anho; a >= 2021; a--) {
            anhosOpt += `<option value="${a}" ${(a == anho) ? 'required': ''}>${a}</option>`;
        }
        return `<div class="row form-group my-1">
        <div class="col">
        <div class="my-1">Pegar los datos de excel. <span class="fst-italic">Los correos deben estar separados por comas</span></div>
        <textarea class="form-control" name="data-importar" id="data-importar" placeholder="Grado, Sección, Correos"></textarea>
        </div>
        </div>
        <div class="row form-group my-1">
        <div class="col text-end my-2">
            <button class="btn btn-sm btn-primary" id="btn-formatear-datos">Formatear datos</button>
        </div>
        <div class="row form-group my-1">
        <div class="col-12">
            <table class="table table-sm table-bordered" id="aulas-para-importar">
                <thead>
                    <tr>
                        <td>#</td>
                        <td>Grado</td>
                        <td>Sección</td>
                        <td>Correos</td>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
        </div>
        </div>
        <form>
        <div class="row form-group my-1">
        <label for="anho" class="col-form-label col col-md-4">Año</label>
        <div class="col col-md-8">
            <select name="anho" id="anho" required class="form-select form-select-sm">${anhosOpt}</select>
            <div class="d-none" id="hidden-fields"></div>
        </div>
    </div>
        </form>
        `;
    }
}
